/* eslint-disable max-len */
import { SvgProps } from './types'

export const SpeechBubbleIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="38"
      viewBox="0 0 40 38" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      {...rest}
    >
      <path d="M12.5 12.75C11.1193 12.75 10 13.8693 10 15.25C10 16.6307 11.1193 17.75 12.5 17.75C13.8807 17.75 15 16.6307 15 15.25C15 13.8693 13.8807 12.75 12.5 12.75Z" fill={drawColor} />
      <path d="M17.5 15.25C17.5 13.8693 18.6193 12.75 20 12.75C21.3807 12.75 22.5 13.8693 22.5 15.25C22.5 16.6307 21.3807 17.75 20 17.75C18.6193 17.75 17.5 16.6307 17.5 15.25Z" fill={drawColor} />
      <path d="M27.5 12.75C26.1193 12.75 25 13.8693 25 15.25C25 16.6307 26.1193 17.75 27.5 17.75C28.8807 17.75 30 16.6307 30 15.25C30 13.8693 28.8807 12.75 27.5 12.75Z" fill={drawColor} />
      <path fillRule="evenodd" clipRule="evenodd" d="M6.25 0.25C2.79822 0.25 0 3.04822 0 6.5V24C0 27.4517 2.79822 30.25 6.25 30.25H6.26514L6.27676 36.098C6.27777 36.6091 6.58989 37.0681 7.06484 37.257C7.53977 37.4459 8.08187 37.3266 8.43365 36.9557L14.7948 30.25H33.75C37.2018 30.25 40 27.4517 40 24V6.5C40 3.04822 37.2018 0.25 33.75 0.25H6.25ZM2.5 6.5C2.5 4.42894 4.17894 2.75 6.25 2.75H33.75C35.8211 2.75 37.5 4.42894 37.5 6.5V24C37.5 26.0711 35.8211 27.75 33.75 27.75H14.2575C13.9145 27.75 13.5866 27.8909 13.3506 28.1397L8.77055 32.968L8.76265 28.9975C8.76129 28.3081 8.20204 27.75 7.51266 27.75H6.25C4.17894 27.75 2.5 26.0711 2.5 24V6.5Z" fill={drawColor} />
    </svg>
  )
}
